import { FileUpload } from "@/components/file-upload"
import { useAppConfig } from "@/stores/appConfigStore"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"

interface Props {
	files: File[]
	setFiles(files: File[]): void

	required?: boolean
}

const DocumentsFileUpload: ReactiveComponent<Props> = (props, { attrs }) => {
	const config = useAppConfig()

	return () => (
		<FileUpload
			files={props.files}
			setFiles={props.setFiles}
			accept={config.fileMimeTypes}
			maxFileSizeBytes={config.maxUploadSize}
			required={props.required}
			multiple
			{...attrs}
		/>
	)
}

export default defineComponent(DocumentsFileUpload, inferProps<Props>())
